export class Ciudad{
	constructor(
	    	public id: String = "",
			public nombre: String = "",
			public codigo: String = "",
			public empresa_id: String = "",
			public usuario_id: String = null,
	){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/ciudad.ts